import React from "react";
import "./APIIntegration.scss";

const ApiIntegration = () => {
  return (
    <div className="main-right-side-section">
      <div className="apiinteger-main-section">
        <section>
          <div className="apiinteger-section-1">
            <div className="apiinteger-section-1-inner">
              <p>ApiIntegration Component</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

ApiIntegration.propTypes = {};

ApiIntegration.defaultProps = {};

export default ApiIntegration;
